import React from "react";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

import moment from "moment";

export default ({ headings, data }) => {
  moment.locale("en");
  return (
    <TableContainer>
      <Table size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            {headings.map((heading) => (
              <TableCell key={heading}>{heading}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data &&
            data.map((row) => (
              <TableRow key={row.eposides_of_care_id}>
                <TableCell component="th" scope="row">
                  {moment(row.date).format("DD/MM/YYYY HH:MM:SS")}
                </TableCell>
                <TableCell>{row.event_type}</TableCell>
                <TableCell>{row.discharge_note}</TableCell>
                <TableCell>{row.discharge_to}</TableCell>
                <TableCell>{row.facility}</TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
